module.exports = __webpack_public_path__ + "static/media/courses1.fa38ee9e.png";